import { Component, Input, Output, OnChanges, SimpleChanges, EventEmitter } from '@angular/core';
import { AppMainComponent } from 'src/app/app.main.component';
import { reportNames } from "../constants";
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as FileSaver from 'file-saver';
import { TimeConvertPipe } from 'src/app/modules/shared/pipes/timeConvert.pipe';
import { LocalDatePipe } from 'src/app/modules/shared/pipes/local-date.pipe';
import { ReportsVisitsLabelName, ReportsVisitsNames } from '../models/reports-visits.enums';
import { PrintPdfModel } from '../models/reports-print-pdf-model';
import { ReportsPrintPdfService } from '../servies/reports-print-pdf.service';
import { latlngDistance } from '../../modules/shared/helpers/distance-from-two-latlng.helpers';

@Component({
    selector: 'app-table2',
    templateUrl: './table2.component.html',
    styleUrls: ['./table2.component.scss'],
    providers: [TimeConvertPipe, LocalDatePipe]
})
export class Table2Component implements OnChanges {
    // reportNames = reportNames;
    reportsName = ReportsVisitsLabelName;
    reportsVisitsNames = ReportsVisitsNames;
    showRows = 15;
    organizationName = this.app.user.organizationName;

    @Input() dateFrom = new Date();
    @Input() dateTo = new Date();
    @Input() products;
    @Input() columns;
    @Input() showHeader;
    @Input() reportName;
    @Input() reportDate;
    @Input() selectedWindow;

    @Output() exportPdf = new EventEmitter<any>();

    displayVisit = false;
    visits: any[] = [];
    tempParent;
    tempChild;
    today = new Date();
    first = 0;
    tableShowMore: number[] = null;

    constructor(
        public app: AppMainComponent,
        private timeConvertPipe: TimeConvertPipe,
        private localDatePipe: LocalDatePipe) { }

    ngOnChanges(changes: SimpleChanges): void {
        if(changes?.selectedWindow?.currentValue){
            this.selectedWindow = changes?.selectedWindow?.currentValue;
        }

        if (changes?.products?.currentValue) {
            this.products = changes?.products?.currentValue;
            this.generateShowMore(this.products?.length);
            this.resetPagination();
        }
        // console.log(this.products);
    }

    generateShowMore(counts: number = 0){
        this.tableShowMore = null;
        this.showRows = 15;
        if(counts>this.showRows){
            this.tableShowMore = [this.showRows,30];

            if(counts>30){
                this.tableShowMore.push(50);
            }

            if(counts>50){
                this.tableShowMore.push(100);
            }
        }
    }

    //Rset the pagination
    resetPagination() {
        this.first = 0;
    }
    msToTime(ms) {
        let seconds = Number((ms / 1000).toFixed(1));
        let minutes = Number((ms / (1000 * 60)).toFixed(1));
        let hours = Number((ms / (1000 * 60 * 60)).toFixed(1));
        let days = Number((ms / (1000 * 60 * 60 * 24)).toFixed(1));
        if (seconds < 60) return seconds + " Sec";
        else if (minutes < 60) return minutes + " Min";
        else if (hours < 24) return hours + " Hrs";
        else return days + " Days"
    }

    openChild(product) {
        for (let s of product.children) {
            let arr = [];
            let last = [];
            for (let c of s.visit) {
                let start = new Date(c.checkin).getTime();
                let end = new Date(c.checkout).getTime();
                let timeSpend = end - start;
                c.timeSpend = this.msToTime(timeSpend);
                arr.push(timeSpend);
                last.push(end);
            }
            let totalSpend = arr.reduce((acc, cur) => acc + cur, 0);
            s.timeSpend = this.msToTime(totalSpend);
            s.visitCounts = s.visit.length;
            s.lastDate = (new Date(Math.max(...last))).toLocaleDateString();
        }
    }

    onRowSelect(product, s) {
        if ([this.reportsName.avareagefieldvisitbyrep, this.reportsName.getaccountfieldvisithistorybyrep, this.reportsName.getleadfieldvisithistorybyrep
            , this.reportsName.getterritorywiseaccountvisithistoryofrep, this.reportsName.getterritorywiseleadvisithistoryofrep
            , this.reportsName.getterritorywiseaccountvisithistory, this.reportsName.getterritorywiseleadvisithistory]
            .includes(this.reportName)) {

            s.visitsdetail = s.visitsdetail||s.visitsDetail||[];

            s?.visitsdetail?.map(visitDetails=>{

                const storeLat = parseFloat(visitDetails['latitude']);
                const storeLng = parseFloat(visitDetails['longitude']);

                const checkinLat =  parseFloat(visitDetails['starttimelatitude']);
                const checkinLlng =  parseFloat(visitDetails['starttimelongitude']);

                const checkOutLat =  parseFloat(visitDetails['endtimelatitude']);
                const checkOutLlng =  parseFloat(visitDetails['endtimelongitude']);

                if(storeLat && storeLng && checkinLat && checkinLlng){
                    const distance = latlngDistance(storeLat,storeLng,checkinLat,checkinLlng);
                    visitDetails['checkinDistance'] = `${distance} Miles`;
                }else{
                    visitDetails['checkinDistance'] = "Address Missing";
                }

                if(storeLat && storeLng && checkOutLat && checkOutLlng){
                    const distance = latlngDistance(storeLat,storeLng,checkOutLat,checkOutLlng);
                    visitDetails['checkoutDistance'] = `${distance} Miles`;
                }else{
                    visitDetails['checkoutDistance'] = "Address Missing";
                }

                visitDetails['checkoutProcess'] = visitDetails?.autocheckedout ? 'Auto' : 'Mannually';

            })


            this.visits = s.visitsdetail;

            if([this.reportsName.getterritorywiseaccountvisithistoryofrep, this.reportsName.getterritorywiseleadvisithistoryofrep,
                this.reportsName.getterritorywiseaccountvisithistory, this.reportsName.getterritorywiseleadvisithistory
            ].includes(this.reportName)){
                const visitUserGroup = this.visits.reduce((acc, curr) => {
                    const { username } = curr;
                    if (!acc[username]) {
                        acc[username] = [];
                    }

                    acc[username].push(curr);
                    return acc;
                }, {});

                let visitList: any[] = [];
                Object.keys(visitUserGroup).map(username=>{
                    visitList.push({
                        repname: username,
                        rowColor: 'child-color2 p-text-bold'
                    });
                    visitUserGroup[username] = visitUserGroup[username].sort((a, b)=> new Date(b.datetime).getTime() - new Date(a.datetime).getTime());
                    let currentColor = 'child-color2';
                    visitUserGroup[username].map((visitDetails, index)=>{
                        const currentDate = this.localDatePipe.transform(visitDetails['datetime'], 'MM/DD/YYYY');
                        const lastDate = this.visits?.[(index-1)] ? this.localDatePipe.transform(this.visits[(index-1)]['datetime'], 'MM/DD/YYYY') : null;
                        let diff = !!(currentDate == lastDate);

                        if(diff){
                            visitDetails.rowColor = this.visits[index-1].rowColor;
                        }else{
                            visitDetails.rowColor = currentColor=='child-color1' ? 'child-color2' : 'child-color1';
                        }

                        currentColor = visitDetails.rowColor;
                    })

                    visitList = [...visitList,...visitUserGroup[username]];
                });
                this.visits = visitList;
            }else if([this.reportsName.avareagefieldvisitbyrep].includes(this.reportName)){
                const visitUserGroup = this.visits.reduce((acc, curr) => {
                    const { businessname } = curr;
                    if (!acc[businessname]) {
                        acc[businessname] = [];
                    }

                    acc[businessname].push(curr);
                    return acc;
                }, {});

                let visitList: any[] = [];
                Object.keys(visitUserGroup).map(businessname=>{
                    visitList.push({
                        businessnameGroup: businessname,
                        rowColor: 'child-color2 p-text-bold'
                    });
                    visitUserGroup[businessname] = visitUserGroup[businessname].sort((a, b)=> new Date(b.datetime).getTime() - new Date(a.datetime).getTime());
                    let currentColor = 'child-color2';
                    visitUserGroup[businessname].map((visitDetails, index)=>{
                        const currentDate = this.localDatePipe.transform(visitDetails['datetime'], 'MM/DD/YYYY');
                        const lastDate = this.visits?.[(index-1)] ? this.localDatePipe.transform(this.visits[(index-1)]['datetime'], 'MM/DD/YYYY') : null;
                        let diff = !!(currentDate == lastDate);

                        if(diff){
                            visitDetails.rowColor = this.visits[index-1].rowColor;
                        }else{
                            visitDetails.rowColor = currentColor=='child-color1' ? 'child-color2' : 'child-color1';
                        }

                        currentColor = visitDetails.rowColor;
                    })

                    visitList = [...visitList,...visitUserGroup[businessname]];
                });
                this.visits = visitList;
            }else{
                let currentColor = 'child-color2';
                this.visits.map((visitDetails, index)=>{
                    const currentDate = this.localDatePipe.transform(visitDetails['datetime'], 'MM/DD/YYYY');
                    const lastDate = this.visits?.[(index-1)] ? this.localDatePipe.transform(this.visits[(index-1)]['datetime'], 'MM/DD/YYYY') : null;
                    let diff = !!(currentDate == lastDate);

                    if(diff){
                        visitDetails.rowColor = this.visits[index-1].rowColor;
                    }else{
                        visitDetails.rowColor = currentColor=='child-color1' ? 'child-color2' : 'child-color1';
                    }

                    currentColor = visitDetails.rowColor;
                })
            }



            this.tempParent = product;
            this.tempChild = s;
            if (this.visits.length > 0) {
                this.displayVisit = true;
            } else {
                this.displayVisit = false;
            }
        }
    }

    openAsPDF(businessName: string, repName: string) {
        let pdfcolumns = [
            { dataKey: 'datetime', header: 'Visit Date' },
            { dataKey: 'checkintime', header: 'Check In Time' },
            { dataKey: 'checkouttime', header: 'Check Out Time' },
            { dataKey: 'checkinDistance', header: 'Check In Distance' },
            { dataKey: 'checkoutDistance', header: 'Check Out Distance' },
            { dataKey: 'checkoutProcess', header: 'Check Out Process' },
            { dataKey: 'deviceinfo', header: 'Device Info' },
            { dataKey: 'timespent', header: 'Time Spent' },
        ];

        if([this.reportsVisitsNames.getterritorywiseaccountvisithistoryofrep, this.reportsVisitsNames.getterritorywiseleadvisithistoryofrep,
            this.reportsVisitsNames.getterritorywiseaccountvisithistory, this.reportsVisitsNames.getterritorywiseleadvisithistory
        ].includes(this.selectedWindow)){
            pdfcolumns = [
                { dataKey: 'repname', header: 'Rep Name' },
                { dataKey: 'datetime', header: 'Visit Date' },
                { dataKey: 'checkintime', header: 'Check In Time' },
                { dataKey: 'checkouttime', header: 'Check Out Time' },
                { dataKey: 'checkinDistance', header: 'Check In Distance' },
                { dataKey: 'checkoutDistance', header: 'Check Out Distance' },
                { dataKey: 'checkoutProcess', header: 'Check Out Process' },
                { dataKey: 'deviceinfo', header: 'Device Info' },
                { dataKey: 'timespent', header: 'Time Spent' },
            ];
        }else if([this.reportsVisitsNames.avareagefieldvisitbyrep].includes(this.selectedWindow)){
            pdfcolumns = [
                { dataKey: 'businessnameGroup', header: 'Name' },
                { dataKey: 'datetime', header: 'Visit Date' },
                { dataKey: 'checkintime', header: 'Check In Time' },
                { dataKey: 'checkouttime', header: 'Check Out Time' },
                { dataKey: 'checkinDistance', header: 'Check In Distance' },
                { dataKey: 'checkoutDistance', header: 'Check Out Distance' },
                { dataKey: 'checkoutProcess', header: 'Check Out Process' },
                { dataKey: 'deviceinfo', header: 'Device Info' },
                { dataKey: 'timespent', header: 'Time Spent' },
            ];
        }

        let dataResult = [];
        for (let data of this.visits) {
            let obj = {
                'datetime': this.localDatePipe.transform(data['datetime'], 'MM/DD/YYYY'),
                'checkintime': this.localDatePipe.transform(data['checkintime'], 'h:mm a'),
                'checkouttime': this.localDatePipe.transform(data['checkouttime'], 'h:mm a'),
                'checkinDistance': data['checkinDistance'],
                'checkoutDistance': data['checkoutDistance'],
                'checkoutProcess': data['checkoutProcess'],
                'deviceinfo': data['deviceinfo'],
                'repname': data['repname'],
                'businessnameGroup': data['businessnameGroup'],
                'timespent': data['timespent'] ? this.timeConvertPipe.transform(data['timespent']) : '',
            };
            dataResult.push(obj);
        }
        ReportsPrintPdfService.openOrExportAsPDF(pdfcolumns, dataResult, this.organizationName, this.dateFrom, this.dateTo, `${businessName} ${this.reportName} ${repName}`, null, null, true);
    }

    downloadAsXLS(repName: string = '') {
        let dataResult = [];

        for (let data of this.visits) {
            let obj: any = {
                'Visit Date': this.localDatePipe.transform(data['datetime'], 'MM/DD/YYYY'),
                'Check In Time': this.localDatePipe.transform(data['checkintime'], 'h:mm a'),
                'Check In Distance': data['checkinDistance'],
                'Check Out Time': this.localDatePipe.transform(data['checkouttime'], 'h:mm a'),
                'Check Out Distance': data['checkoutDistance'],
                'Check Out Process': data['checkoutProcess'],
                'Device Info': data['deviceinfo'],
                'Time Spent': data['timespent'] ? this.timeConvertPipe.transform(data['timespent']) : '',
            };

            if([this.reportsVisitsNames.getterritorywiseaccountvisithistoryofrep, this.reportsVisitsNames.getterritorywiseleadvisithistoryofrep,
                this.reportsVisitsNames.getterritorywiseaccountvisithistory, this.reportsVisitsNames.getterritorywiseleadvisithistory
            ].includes(this.selectedWindow)){
                obj = {
                    'Rep Name': data['repname'],
                    'Visit Date': this.localDatePipe.transform(data['datetime'], 'MM/DD/YYYY'),
                    'Check In Time': this.localDatePipe.transform(data['checkintime'], 'h:mm a'),
                    'Check In Distance': data['checkinDistance'],
                    'Check Out Time': this.localDatePipe.transform(data['checkouttime'], 'h:mm a'),
                    'Check Out Distance': data['checkoutDistance'],
                    'Check Out Process': data['checkoutProcess'],
                    'Device Info': data['deviceinfo'],
                    'Time Spent': data['timespent'] ? this.timeConvertPipe.transform(data['timespent']) : '',
                };
            }else if([this.reportsVisitsNames.avareagefieldvisitbyrep].includes(this.selectedWindow)){
                obj = {
                    'Name': data['businessnameGroup'],
                    'Visit Date': this.localDatePipe.transform(data['datetime'], 'MM/DD/YYYY'),
                    'Check In Time': this.localDatePipe.transform(data['checkintime'], 'h:mm a'),
                    'Check In Distance': data['checkinDistance'],
                    'Check Out Time': this.localDatePipe.transform(data['checkouttime'], 'h:mm a'),
                    'Check Out Distance': data['checkoutDistance'],
                    'Check Out Process': data['checkoutProcess'],
                    'Device Info': data['deviceinfo'],
                    'Time Spent': data['timespent'] ? this.timeConvertPipe.transform(data['timespent']) : '',
                };
            }

            dataResult.push(obj);
        }

        import("xlsx").then(xlsx => {
            const worksheet = xlsx.utils.json_to_sheet(dataResult);
            const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
            const excelBuffer: any = xlsx.write(workbook, { bookType: 'xls', type: 'array' });
            this.saveAsExcelFileXLS(excelBuffer, this.reportName);
        });
    }

    saveAsExcelFileXLS(buffer: any, fileName: string): void {
        let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        let EXCEL_EXTENSION = '.xls';
        const data: Blob = new Blob([buffer], {
            type: EXCEL_TYPE
        });
        FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
    }
}
